import dayjs from '@/lib/dayjs'
import plural from 'plural-ru'
import timeAgo from '@/lib/timeago'

export function formatDate(value: string, format = 'D MMMM YYYY'): string {
  return dayjs(value, 'YYYY-MM-DD').format(format)
}

export function formatDateTime(value: string): string {
  return dayjs(value).format('D MMMM YYYY, HH:mm')
}

export function formatExamDistance(value: string): string {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const diff = dayjs(value, 'YYYY-MM-DD').diff(today, 'days')
  return `Экзамен через ${diff} ${plural(diff, 'день', 'дня', 'дней')}`
}

export function formatDuration(durationDays: number): string {
  return timeAgo.format(dayjs().subtract(durationDays, 'day').toDate()).replace(' назад', '')
}

export function formatPrice(value: number): string {
  return new Intl.NumberFormat('ru-RU').format(value)
}
